import {
    Accordion,
    AccordionContent,
    AccordionHeader,
} from '@eventbrite/eds-accordion';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import styles from './faqItem.module.scss';

export type SectionData = {
    name: string;
    urlPath?: string;
    id: string;
};

export type FAQItemProps = {
    questionText: GenericLazyString;
    answerText: GenericLazyString;
    children?: React.ReactNode;
    sectionData?: Array<SectionData>;
};

export const SectionData = ({ name, urlPath, id }: SectionData) => {
    return (
        <li className={styles.sectionData} data-testid="section-data">
            {urlPath ? (
                <a key={`sectionData-link ${id}`} href={urlPath}>
                    {name}
                </a>
            ) : (
                <p key={`sectionData-text ${id}`}>{name}</p>
            )}
            <br />
        </li>
    );
};

export const FAQItem = ({
    questionText,
    answerText,
    children,
    sectionData,
}: FAQItemProps) => {
    return (
        <div className={styles.faqItem} data-testid="faqItems">
            <Accordion>
                <div
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                >
                    <AccordionHeader>
                        <div className={styles.faqHeader} itemProp="name">
                            {questionText}
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        <div
                            itemScope
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                        >
                            <div className={styles.faqContent}>
                                <div>{answerText}</div>
                                {children && <div>{children}</div>}

                                {sectionData && (
                                    <div>
                                        {sectionData.map(
                                            ({ name, urlPath, id }) => (
                                                <SectionData
                                                    key={id}
                                                    name={name}
                                                    urlPath={urlPath}
                                                    id={id}
                                                />
                                            ),
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </AccordionContent>
                </div>
            </Accordion>
        </div>
    );
};
